import React from 'react';
import styled from 'react-emotion';
import ContentItem from '../index';

const BlockQuote = styled.div`
`;

export default (props) => {
  const { content = [] } = props;
  return (
    <BlockQuote>
      {content.map(item => (
        <ContentItem key={item.id} {...item} />
      ))}
    </BlockQuote>
  );
};
